import React from "react";
import Modal from "../Common/Modal";
import MtiButton from "../Buttons/MtiButton";
import styles from "./ClearPlateConfirmationModal.module.css";
import MessageContainer from "../Common/MessageContainer/MessageContainer";

interface ClearPlateConfirmationModalProps {
  plateBarcode: string;
  isOpen: boolean;
  onCancel: () => void;
  onOk: () => void;
}

function ClearPlateConfirmationModal(props: ClearPlateConfirmationModalProps) {
  const { isOpen, onCancel, onOk, plateBarcode } = props;
  return (
    <Modal show={isOpen} className={styles.modal}>
      <Modal.Header
        className={styles.modalHeader}
        title={"Remove Registered Plate from System"}
        hideButtonEnabled={false}
      />
      <Modal.Body className={styles.modalBody}>
        <p className={styles.message}>
          Remove plate {plateBarcode} data from system?
        </p>
        <MessageContainer
          message="Make sure physical plate has been removed from system"
          variant="warning"
        />
      </Modal.Body>
      <Modal.Footer>
        <div className={styles.footer}>
          <MtiButton
            onClick={onCancel}
            variant="secondary"
            colorVariant="default"
          >
            No
          </MtiButton>
          <MtiButton onClick={onOk} variant="primary" colorVariant="default">
            Yes
          </MtiButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ClearPlateConfirmationModal;
